export const WHITE = 'rgba(255, 255, 255, 1)';
export const BLACK_1 = 'rgba(0, 0, 0, 1)';
export const BLACK_01 = 'rgba(0, 0, 0, 0.1)';
export const BLACK_02 = 'rgba(0, 0, 0, 0.2)';
export const BLACK_08 = 'rgba(0, 0, 0, 0.8)';
export const BLACK_005 = 'rgba(0, 0, 0, 0.05)';
export const DODGERBLUE_1 = 'rgba(34, 119, 246, 1)'; // #2277F6
